import { PlayerColor, TradeResponseStatus } from '@colonist/game-states';
import { UIGameState } from './UIGameState.ts';
import { GameSettings } from '@colonist/game-base-types';
import { ArrayUtils } from '@colonist/utils';
import { getEmptyPlayerState } from '@colonist/game-state-types';
import { BankValidator, CurrentStateValidator, GameValidator, MapValidator, MechanicValidatorDevelopmentCard, MechanicValidatorProgressCards, PlayerValidator } from '@colonist/game-mechanic-validators';
import { DeviceType, LobbyImage } from '@colonist/types';
import { CA } from '../analytics/Analytics.ts';
// TODO rename this class later
export class UIGameController {
    get currentState() {
        return this.currentStateValidator.currentState;
    }
    applyStateUpdates(stateUpdate) {
        this.stateController.applyStateUpdates(stateUpdate);
    }
    botSessionCount() {
        let amount = 0;
        for (const player of this.playerValidators.values()){
            if (player.isUser) continue;
            amount += 1;
        }
        return amount;
    }
    getPlayerState(player) {
        const isPlayerSpectator = player == PlayerColor.None;
        if (isPlayerSpectator) {
            return new PlayerValidator(getEmptyPlayerState(), {
                userId: undefined,
                username: '',
                databaseIcon: LobbyImage.Bot,
                isBot: false,
                deviceType: DeviceType.Unknown,
                countryCode: undefined,
                regionUpdated: undefined,
                membership: undefined,
                selectedColor: PlayerColor.None,
                profilePictureUrl: undefined
            });
        }
        const playerValidator = this.playerValidators.get(player);
        if (playerValidator != undefined) return playerValidator;
        throw new Error('no player found: ' + PlayerColor[player]);
    }
    getPlayerValidators() {
        const playerValidators = [];
        for (const [playerColor, playerControllerState] of this.playerValidators){
            playerValidators.push(playerControllerState);
        }
        return playerValidators;
    }
    getPlayerValidatorsMap() {
        return this.playerValidators;
    }
    amITakingAction() {
        // Returns true if I am taking action or if no one else is taking action and it is my turn.
        return this.gameValidator.getPlayersTakingAction().includes(this.myColor);
    }
    wasATradeAccepted() {
        for (const activeTradeState of Object.values(this.tradeState.activeOffers)){
            if (activeTradeState == undefined) continue;
            for (const player of Object.keys(activeTradeState.playerResponses)){
                const playerColor = Number(player);
                if (activeTradeState.playerResponses[playerColor] == TradeResponseStatus.Accepted) return true;
            }
        }
        return false;
    }
    getPlayerColors() {
        return [
            ...this.playerValidators.keys()
        ];
    }
    get isMyTurn() {
        if (this.currentStateValidator == undefined) return false;
        return this.currentStateValidator.currentTurnPlayers.includes(this.myColor);
    }
    get myActionState() {
        if (this.currentStateValidator == undefined) return this.currentState.actionState;
        return this.currentStateValidator.getPlayerActionState(this.myColor);
    }
    get isPlayerSpectator() {
        if (this.myColor == PlayerColor.None) return true;
        return false;
    }
    getAllCardsInHand(player) {
        var _this_devCardsValidator, _this_progressCardsValidator;
        const allCards = [];
        allCards.push(...this.getPlayerState(player).resourceCards.cards);
        const devCards = (_this_devCardsValidator = this.devCardsValidator) === null || _this_devCardsValidator === void 0 ? void 0 : _this_devCardsValidator.getDevelopmentCardsPlayerState(player).developmentCards;
        if (devCards) allCards.push(...devCards.cards);
        const progressCards = (_this_progressCardsValidator = this.progressCardsValidator) === null || _this_progressCardsValidator === void 0 ? void 0 : _this_progressCardsValidator.getProgressCardsPlayerValidator(player).progressCards;
        if (progressCards) allCards.push(...progressCards.cards);
        return allCards;
    }
    totalResourceCardOfType(player, cardEnum) {
        return ArrayUtils.countOccurenceOfValueInArray(this.getAllCardsInHand(player), cardEnum);
    }
    getPlayerNameWithColor(color) {
        return {
            key: 'strings:colonistCommon.utils.#buffer',
            options: {
                value: this.getPlayerState(color).username
            }
        };
    }
    getPlayerBankTradeRatios(player) {
        if (player == PlayerColor.None) return [];
        const playerState = this.getPlayerState(player);
        const bankTradeRatiosState = playerState.bankTradeRatiosState;
        const bankTradeRatiosArray = Object.entries(bankTradeRatiosState).map(([resource, tradeRatio])=>({
                resource: resource,
                tradeRatio: tradeRatio
            }));
        return bankTradeRatiosArray;
    }
    is1v1() {
        return this.playOrder.length == 2;
    }
    isBotGame() {
        return this.botSessionCount() == this.playOrder.length - 1;
    }
    constructor(uiGameManager, configurations){
        var _configurations_gameState_experimentalMechanicState, _configurations_gameState_experimentalMechanicState1, _configurations_gameState_experimentalMechanicState2, _configurations_gameState_experimentalMechanicState3;
        this.uiGameManager = uiGameManager;
        this.stateController = new UIGameState(configurations.gameState);
        this.gameDetails = configurations.gameDetails;
        this.gameSettings = GameSettings.deserialize(configurations.gameSettings);
        this.uiGameManager.gameState.initGameModeData(configurations.gameSettings.modeSetting);
        this.timeLeftInCurrentState = configurations.timeLeftInState;
        this.gameValidator = new GameValidator(configurations.gameState, configurations.playerUserStates);
        this.diceState = configurations.gameState.diceState;
        this.mapValidator = new MapValidator(configurations.gameState.mapState);
        this.bankState = new BankValidator(configurations.gameState.bankState);
        const experimentalCurrentState = (_configurations_gameState_experimentalMechanicState = configurations.gameState.experimentalMechanicState) === null || _configurations_gameState_experimentalMechanicState === void 0 ? void 0 : _configurations_gameState_experimentalMechanicState.currentState;
        const mechanicTurnColonistRushState = (_configurations_gameState_experimentalMechanicState1 = configurations.gameState.experimentalMechanicState) === null || _configurations_gameState_experimentalMechanicState1 === void 0 ? void 0 : _configurations_gameState_experimentalMechanicState1.mechanicTurnColonistRushState;
        const mechanicRobberColonistRushState = (_configurations_gameState_experimentalMechanicState2 = configurations.gameState.experimentalMechanicState) === null || _configurations_gameState_experimentalMechanicState2 === void 0 ? void 0 : _configurations_gameState_experimentalMechanicState2.mechanicRobberColonistRushState;
        const playerStates = (_configurations_gameState_experimentalMechanicState3 = configurations.gameState.experimentalMechanicState) === null || _configurations_gameState_experimentalMechanicState3 === void 0 ? void 0 : _configurations_gameState_experimentalMechanicState3.playerStates;
        const playerColors = configurations.playerUserStates.map((userState)=>userState.selectedColor);
        this.currentStateValidator = new CurrentStateValidator(configurations.gameState.currentState, experimentalCurrentState, mechanicTurnColonistRushState, playerStates, playerColors, mechanicRobberColonistRushState);
        this.playerValidators = new Map();
        this.uiGameManager.gameState.players = [];
        for(const playerColorKey in configurations.gameState.playerStates){
            const playerColor = Number(playerColorKey);
            const playerState = configurations.gameState.playerStates[playerColor];
            if (playerState == undefined) continue;
            const userState = configurations.playerUserStates.find((playerUserState)=>playerUserState.selectedColor === playerColor);
            if (userState == undefined) continue;
            const playerStateController = new PlayerValidator(playerState, userState);
            this.playerValidators.set(playerStateController.color, playerStateController);
            this.uiGameManager.gameState.initPlayerControllerStates(playerState, userState);
        }
        this.playOrder = configurations.playOrder;
        this.myColor = configurations.playerColor;
        const { mechanicDevelopmentCardsState, mechanicProgressCardsState } = configurations.gameState;
        if (mechanicDevelopmentCardsState) this.devCardsValidator = new MechanicValidatorDevelopmentCard(this.getPlayerValidators(), this.mapValidator, this.currentStateValidator, mechanicDevelopmentCardsState);
        if (mechanicProgressCardsState) this.progressCardsValidator = new MechanicValidatorProgressCards(this.getPlayerValidators(), this.mapValidator, mechanicProgressCardsState);
        this.tradeState = configurations.gameState.tradeState;
        var _configurations_isReplay;
        this.isReplay = (_configurations_isReplay = configurations.isReplay) !== null && _configurations_isReplay !== void 0 ? _configurations_isReplay : false;
        uiGameManager.gameState.initMapState(this.mapValidator);
        void CA.sessionRecorder.conditionallyStartRecording(this.gameSettings.modeSetting);
    }
}
